<template>
  <InputGroup :class="cn('tw:bg-background', $attrs.class)">
    <InputGroupInput
      v-model="searchValue"
      type="text"
      :placeholder="placeholder"
      :name="name"
      @keyup.enter="onSearch"
      @keydown.stop=""
    />

    <slot name="addon" />

    <slot
      :search-value="searchValue"
      :on-search="onSearch"
      :clear-search-value="clearSearchValue"
    >
      <InputGroupAddon
        align="inline-end"
      >
        <InputGroupButton
          type="button"
          data-slot="search-button"
          size="icon-sm"
          class="tw:rounded-full"
          @click="onSearch"
        >
          <i class="tw:i-fal-magnifying-glass tw:size-4" />
        </InputGroupButton>
      </InputGroupAddon>
    </slot>
  </InputGroup>
</template>

<script setup>
import { useVModel } from '@vueuse/core'
import { InputGroup, InputGroupAddon, InputGroupButton, InputGroupInput } from '@/shadcn/components/ui/input-group/index.js'
import { cn } from '@/shadcn/lib/utils.js'

defineOptions({
  name: 'SearchInput',
  inheritAttrs: false,
})

const props = defineProps({
  modelValue: {
    type: String,
    default: '',
  },
  placeholder: {
    type: String,
    default: 'Search...',
  },
  name: {
    type: String,
  },
})

const emit = defineEmits(['update:modelValue', 'search'])

const searchValue = useVModel(props)

function onSearch() {
  emit('search', searchValue.value)
}

function clearSearchValue() {
  searchValue.value = ''
}
</script>
